import { WebSettingsResponse } from '../dto/WebSettings';

const endpoint = process.env.REACT_APP_API_ENDPOINT;

export class WebService{
    
    public static GetWebSettings=async (): Promise<WebSettingsResponse>=>{
        try {
             const response = await fetch(`${endpoint}/websettings/get`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                }
            });
            if (!response.ok) {
                throw new Error(`Error ${response.status}: ${response.statusText}`);
            }
            
            const data = await response.json();
            return data;
        } catch (er: any) {
            throw new Error(er.message);
        }
    }
        
}
